module.exports = __webpack_public_path__ + "img/sonorizacao.a58fe04e.svg";